import React from 'react';

interface OperationsHeaderProps {
    mode: string;
    jointNumber: number;
    isUpdating: boolean;
    lastUpdate: string;
    activeAlarmCount: number;
    JoindId: string;
}

export const OperationsHeader: React.FC<OperationsHeaderProps> = ({
    mode,
    jointNumber,
    isUpdating,
    lastUpdate,
    activeAlarmCount,
    JoindId,
}) => {
    return (
        <div className="mb-6 flex flex-col gap-3 border-b border-gray-200 pb-4">
            <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
                <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
                    <div className="flex items-center gap-2">
                        <div className={`h-3 w-3 rounded-full ${mode === 'Joint' ? 'bg-red-500' : 'bg-yellow-500'}`}></div>
                        <span className="font-semibold text-gray-900">{mode.toUpperCase()} MODE</span>
                    </div>
                    <div className="inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-gray-50 px-2.5 py-0.5 text-xs font-medium text-gray-700">
                        <div className="h-1.5 w-1.5 rounded-full bg-purple-500" />
                        <span>Joint #{jointNumber ?? '-'}</span>
                    </div>
                    {JoindId != null && JoindId !== '' && (
                        <div className="inline-flex items-center gap-1.5 rounded-full border border-[#E2E5EA] bg-[rgba(0,39,63,0.06)] px-2.5 py-0.5 text-xs font-medium text-blueprint-blue">
                            <div className="h-1.5 w-1.5 rounded-full bg-blueprint-blue" />
                            <span>Joint ID: {JoindId}</span>
                        </div>
                    )}
                </div>
                <span className="shrink-0 text-sm font-medium text-red-600">
                    {activeAlarmCount} Active Alarms
                </span>
            </div>
            <div className="flex min-w-0 items-center gap-2">
                {isUpdating && (
                    <div className="h-2 w-2 shrink-0 rounded-full bg-blue-500 animate-pulse"></div>
                )}
                <span className="min-w-0 break-words text-xs text-gray-500">
                    Last Record Timestamp: {lastUpdate} UTC
                </span>
            </div>
        </div>
    );
};

